import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setAuthData } from "./slices/authSlice";
import { Routes, Route } from "react-router-dom";
import { routes } from "./routesConfig";

import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import Tabbar from "./Components/TabBar/TabBar";

import "./App.css";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchEventId = async () => {
      try {
        const response = await fetch("https://apis.sihs.org.pk/api/EventPortal/CurrentEvent", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        });

        if (!response.ok) {
          throw new Error("Failed to fetch event ID");
        }

        const data = await response.json();
        if (data?.Table?.length > 0) {
          const eventId = data.Table[0].EventId;
          dispatch(setAuthData({ eventId }));
        }
      } catch (error) {
        console.error("Error fetching event ID:", error);
      }
    };

    fetchEventId();
  }, [dispatch]);

  return (
    <div className="main-styles">
      <Tabbar />
      <Navbar />
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
